<div class="loader-box" *ngIf="!showBlur">
    <div class="loader"></div>
</div>

<div class="loader-overlay" *ngIf="showBlur">
    <div class="loader-box">
        <div class="loader"></div>
    </div>
</div>